// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Link = require("./link");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Fetch = require("bs-fetch/lib/js/src/Fetch.js");
var Theme = require("./theme");
var React = require("react");
var Network = require("./network");
var Json_encode = require("@glennsl/bs-json/lib/js/src/Json_encode.bs.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Code_inputSvg = require("./assets/code_input.svg");
var Mail_inputSvg = require("./assets/mail_input.svg");
var Register_iconSvg = require("./assets/register_icon.svg");
var Password_inputSvg = require("./assets/password_input.svg");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var register = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var registerHeadBox = Css.style(/* :: */[
      Css.position(Css.relative),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.flexDirection(Css.column),
                /* :: */[
                  Css.margin4(Css.px(20), Css.px(0), Css.px(0), Css.px(0)),
                  /* :: */[
                    Css.fontSize(Css.px(24)),
                    /* :: */[
                      Css.width(Css.px(110)),
                      /* :: */[
                        Css.height(Css.px(110)),
                        /* :: */[
                          Css.borderRadius(/* `percent */[
                                -119887163,
                                50.0
                              ]),
                          /* :: */[
                            Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var registerIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.1,
                  1.1
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      -50.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(/* `percent */[
                  -119887163,
                  53.0
                ]),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(35)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var inputBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.padding(Css.px(10)),
                /* :: */[
                  Css.boxSizing(/* borderBox */9307263),
                  /* :: */[
                    Css.position(Css.relative),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputFieldBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.position(Css.relative),
            /* :: */[
              Css.boxSizing(/* borderBox */9307263),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding4(Css.px(5), Css.px(10), Css.px(5), Css.px(50)),
        /* :: */[
          Css.fontSize(Css.px(18)),
          /* :: */[
            Css.minHeight(Css.px(40)),
            /* :: */[
              Css.maxWidth(Css.px(300)),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.minWidth(Css.px(220)),
                  /* :: */[
                    Css.borderRadius(/* `px */[
                          25096,
                          50
                        ]),
                    /* :: */[
                      Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                            5194459,
                            "F492BD"
                          ]),
                      /* :: */[
                        Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                        /* :: */[
                          Css.boxSizing(/* borderBox */9307263),
                          /* :: */[
                            Css.position(Css.relative),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var mailInput = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      0.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.left(Css.px(18)),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(25)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var codeInput = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.05,
                  1.05
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      0.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.left(Css.px(18)),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(21)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var passwordInput = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(0)),
      /* :: */[
        Css.transforms(/* :: */[
              /* `scale */[
                -120664438,
                /* tuple */[
                  1.05,
                  1.05
                ]
              ],
              /* :: */[
                /* `translate */[
                  -914368690,
                  /* tuple */[
                    /* `percent */[
                      -119887163,
                      0.0
                    ],
                    Css.px(0)
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.left(Css.px(18)),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.zIndex(2),
              /* :: */[
                Css.top(Css.px(21)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* register */register,
  /* registerHeadBox */registerHeadBox,
  /* registerIcon */registerIcon,
  /* inputBox */inputBox,
  /* inputFieldBox */inputFieldBox,
  /* inputField */inputField,
  /* mailInput */mailInput,
  /* codeInput */codeInput,
  /* passwordInput */passwordInput,
  /* someLink */someLink
];

function text(prim) {
  return prim;
}

function validatePassword(value) {
  var match = +(value.length > 5);
  if (match !== 0) {
    return /* PassValid */0;
  } else {
    return /* PassNotValid */["Password zu kurz"];
  }
}

function validateEmail(value) {
  var emailRegex = (/.*@.*\..+/);
  if (value === "") {
    return /* Some */["Email Feld leer"];
  } else if (emailRegex.test(value)) {
    return /* None */0;
  } else {
    return /* Some */["Email Adresse enthält Fehler"];
  }
}

function showApiError(data, self, message) {
  return Promise.resolve(data).then((function () {
                  console.log("Login error!");
                  Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(3, [message]));
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("API error exception", err), /* () */0));
              }));
}

var component = ReasonReact.reducerComponent("Register");

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      var send = param[/* send */4];
      var state = param[/* state */2];
      var match = state[/* error */3];
      var match$1 = state[/* success */4];
      var match$2 = state[/* loading */5];
      return React.createElement("div", {
                  className: register
                }, React.createElement("div", {
                      className: registerHeadBox
                    }, React.createElement("img", {
                          className: registerIcon,
                          alt: "icon",
                          src: Register_iconSvg
                        })), React.createElement("h1", undefined, "Registrieren"), React.createElement("div", {
                      className: inputBox
                    }, React.createElement("div", {
                          className: inputFieldBox
                        }, React.createElement("input", {
                              className: inputField,
                              autoFocus: true,
                              placeholder: "Email",
                              type: "email",
                              value: state[/* email */0],
                              onChange: (function ($$event) {
                                  return Curry._1(send, /* ChangeEmail */Block.__(0, [$$event.target.value]));
                                })
                            }), React.createElement("img", {
                              className: mailInput,
                              alt: "mail",
                              src: Mail_inputSvg
                            })), React.createElement("div", {
                          className: inputFieldBox
                        }, React.createElement("input", {
                              className: inputField,
                              placeholder: "Code",
                              type: "text",
                              value: state[/* code */2],
                              onChange: (function ($$event) {
                                  return Curry._1(send, /* ChangeCode */Block.__(1, [$$event.target.value]));
                                })
                            }), React.createElement("img", {
                              className: codeInput,
                              alt: "pass",
                              src: Code_inputSvg
                            })), React.createElement("div", {
                          className: inputFieldBox
                        }, React.createElement("input", {
                              className: inputField,
                              placeholder: "Passwort",
                              type: "password",
                              value: state[/* password */1],
                              onKeyDown: (function ($$event) {
                                  if ($$event.keyCode === 13) {
                                    $$event.preventDefault();
                                    return Curry._1(send, /* RegisterEnterKeyDown */1);
                                  } else {
                                    return Curry._1(send, /* RegisterOtherKeyDown */0);
                                  }
                                }),
                              onChange: (function ($$event) {
                                  return Curry._1(send, /* ChangePassword */Block.__(2, [$$event.target.value]));
                                })
                            }), React.createElement("img", {
                              className: passwordInput,
                              alt: "mail",
                              src: Password_inputSvg
                            }))), match ? React.createElement("div", {
                        className: "failure"
                      }, match[0]) : null, match$1 ? React.createElement("div", {
                        className: "success"
                      }, match$1[0]) : null, React.createElement("button", {
                      className: Theme.simpleButton(/* () */0),
                      onClick: (function () {
                          return Curry._1(send, /* Register */2);
                        })
                    }, match$2 !== 0 ? React.createElement("div", {
                            className: "button-spinner"
                          }) : "Registrieren"), ReasonReact.element(/* None */0, /* None */0, Link.make("/login", "zum Login", someLink, /* array */[])));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* email */Network.getUrlParamCode(/* Email */1),
              /* password */"",
              /* code */Network.getUrlParamCode(/* Code */0),
              /* error : None */0,
              /* success : None */0,
              /* loading : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* SideEffects */Block.__(2, [(function (self) {
                            return Curry._1(self[/* send */4], /* Register */2);
                          })]);
          case 2 : 
              var emailValid = validateEmail(state[/* email */0]);
              if (emailValid) {
                var error = emailValid[0];
                return /* SideEffects */Block.__(2, [(function (self) {
                              return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(3, [error]));
                            })]);
              } else {
                var passwordValid = validatePassword(state[/* password */1]);
                if (passwordValid) {
                  var error$1 = passwordValid[0];
                  return /* SideEffects */Block.__(2, [(function (self) {
                                return Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(3, [error$1]));
                              })]);
                } else {
                  var newrecord = state.slice();
                  return /* UpdateWithSideEffects */Block.__(3, [
                            (newrecord[/* loading */5] = /* true */1, newrecord),
                            (function (self) {
                                var requestPayload = Json_encode.object_(/* :: */[
                                      /* tuple */[
                                        "email",
                                        self[/* state */2][/* email */0]
                                      ],
                                      /* :: */[
                                        /* tuple */[
                                          "password",
                                          self[/* state */2][/* password */1]
                                        ],
                                        /* :: */[
                                          /* tuple */[
                                            "token",
                                            self[/* state */2][/* code */2]
                                          ],
                                          /* [] */0
                                        ]
                                      ]
                                    ]);
                                fetch(Network.registerUrl, Fetch.RequestInit[/* make */0](/* Some */[/* Post */2], /* Some */[{
                                                  "Content-Type": "application/json",
                                                  Accept: "application.json"
                                                }], /* Some */[JSON.stringify(requestPayload)], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0)).then((function (data) {
                                          console.log("breakpoint");
                                          var statusCode = data.status;
                                          console.log("https status: ", statusCode);
                                          var exit = 0;
                                          if (statusCode >= 401) {
                                            if (statusCode >= 413) {
                                              exit = 1;
                                            } else {
                                              switch (statusCode - 401 | 0) {
                                                case 0 : 
                                                    return showApiError(data, self, "Registrierungscode fehlerhaft");
                                                case 8 : 
                                                    return showApiError(data, self, "Email Adresse bereits registriert!");
                                                case 1 : 
                                                case 2 : 
                                                case 3 : 
                                                case 4 : 
                                                case 5 : 
                                                case 6 : 
                                                case 7 : 
                                                case 9 : 
                                                case 10 : 
                                                    exit = 1;
                                                    break;
                                                case 11 : 
                                                    return showApiError(data, self, "Registrierungscode bereits verwendet");
                                                
                                              }
                                            }
                                          } else if (statusCode !== 201) {
                                            exit = 1;
                                          } else {
                                            console.log("Registration success");
                                            Curry._1(self[/* send */4], /* ShowSuccessMessage */Block.__(4, ["Registrierung erfolgreich"]));
                                            return Promise.resolve(/* () */0);
                                          }
                                          if (exit === 1) {
                                            return showApiError(data, self, "Http Fehler: " + String(statusCode));
                                          }
                                          
                                        })).catch((function (err) {
                                        return Promise.resolve((console.log("Api error", err), Curry._1(self[/* send */4], /* ShowErrorMessage */Block.__(3, ["Netzwerkfehler"]))));
                                      }));
                                return /* () */0;
                              })
                          ]);
                }
              }
          case 3 : 
              var newrecord$1 = state.slice();
              return /* Update */Block.__(0, [(newrecord$1[/* error */3] = /* None */0, newrecord$1)]);
          
        }
      } else {
        switch (action.tag | 0) {
          case 0 : 
              var newrecord$2 = state.slice();
              return /* Update */Block.__(0, [(newrecord$2[/* email */0] = action[0], newrecord$2)]);
          case 1 : 
              var newrecord$3 = state.slice();
              return /* Update */Block.__(0, [(newrecord$3[/* code */2] = action[0], newrecord$3)]);
          case 2 : 
              var newrecord$4 = state.slice();
              return /* Update */Block.__(0, [(newrecord$4[/* password */1] = action[0], newrecord$4)]);
          case 3 : 
              var text = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* email */state[/* email */0],
                          /* password */state[/* password */1],
                          /* code */state[/* code */2],
                          /* error : Some */[text],
                          /* success */state[/* success */4],
                          /* loading : false */0
                        ],
                        (function (self) {
                            console.log("ShowErrorMessage Reducer:", text);
                            setTimeout((function () {
                                    return Curry._1(self[/* send */4], /* ClearError */3);
                                  }), 2500);
                            return /* () */0;
                          })
                      ]);
          case 4 : 
              var text$1 = action[0];
              return /* UpdateWithSideEffects */Block.__(3, [
                        /* record */[
                          /* email */state[/* email */0],
                          /* password */state[/* password */1],
                          /* code */state[/* code */2],
                          /* error */state[/* error */3],
                          /* success : Some */[text$1],
                          /* loading : false */0
                        ],
                        (function (self) {
                            console.log("ShowSuccessMessage Reducer:", text$1);
                            setTimeout((function () {
                                    return ReasonReact.Router[/* push */0]("/?email=" + self[/* state */2][/* email */0]);
                                  }), 2500);
                            return /* () */0;
                          })
                      ]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.validatePassword = validatePassword;
exports.validateEmail = validateEmail;
exports.showApiError = showApiError;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/register.re
// module id = 129
// module chunks = 0